<!-- SELECT -->
@if (element.type === "SELECT") {
    <div fxLayout="row" style="width: 100%">
        @if (element.type === "SELECT") {
            <div fxLayout="column" fxLayoutAlign="flex-end start" class="panel-status" fxFlex="80">
                <h1 fxFlex="100" class="m-0 elementHead">
                    {{ element.name }}
                    @if (element.required === 1) {
                        <b style="color: rgb(255, 50, 50)"> *</b>
                    }
                </h1>
            </div>
        }
        @if (element.type === "SELECT") {
            <div
                fxLayout="column"
                fxLayoutAlign="flex-end end"
                class="panel-status"
                style="margin-right: 5%"
                fxFlex="20"
            >
                <!-- ReadOnly -->
                @if (readOnly && userResult.result) {
                    <div fxLayout="row" style="width: 100%; margin: 0px !important; padding: 0px !important">
                        <mat-select
                            class="form-control disabled"
                            [(value)]="userResult.result"
                            disabled
                            placeholder="Seleccione una opción..."
                        >
                            @for (option of selectOptions; track option) {
                                <mat-option [value]="option.value">{{ option.name }}</mat-option>
                            }
                            @if (element.noApplyOption) {
                                <mat-option value="NA">No aplica</mat-option>
                            }
                        </mat-select>
                    </div>
                }
                @if (readOnly && !userResult.result) {
                    <div fxLayout="row" fxLayoutAlign="center center" style="width: 100%">
                        <span>Sin respuesta</span>
                    </div>
                }
                <!-- WriteMode -->
                @if (!readOnly) {
                    <div fxLayout="row" style="width: 100%; margin: 0px !important; padding: 0px !important">
                        <mat-select
                            class="form-control"
                            #filterSelect
                            [(value)]="userResult.result"
                            (selectionChange)="setResult(filterSelect.value)"
                            placeholder="Seleccione una opción..."
                        >
                            @for (option of selectOptions; track option) {
                                <mat-option [value]="option.value">{{ option.name }}</mat-option>
                            }
                            @if (element.noApplyOption) {
                                <mat-option value="NA">No aplica</mat-option>
                            }
                        </mat-select>
                    </div>
                }
            </div>
        }
    </div>
}

@if (element.description && element.type === "SELECT") {
    <div fxLayout="row" fxLayoutAlign="start start" style="margin-right: 5%">
        <div fxFlex="100" class="m-0" [innerHtml]="element.description"></div>
    </div>
}

<!-- TEXTAREA -->
@if (element.description && element.type === "TEXTAREA") {
    <div fxLayout="row" fxLayoutAlign="start start" style="margin-right: 5%">
        <div fxFlex="100" class="m-0" [innerHtml]="element.description"></div>
    </div>
}
@if (element.type === "TEXTAREA") {
    <div>
        <!-- Read only -->
        @if (readOnly && userResult.comment) {
            <div>
                <!-- User -->
                @if (userResult.comment) {
                    <div fxLayout="row" fxLayoutAlign="center center" class="comment-container" style="margin-left: 5%">
                        <div class="m-0 comment" [innerHtml]="userResult.comment"></div>
                    </div>
                }
            </div>
        }
        @if (readOnly && !userResult.comment) {
            <div fxLayout="row" fxLayoutAlign="center center" style="margin-left: 5%">
                <span>Sin respuesta</span>
            </div>
        }
        <!-- Write mode -->
        @if (!readOnly) {
            <div class="mt-16 fullwidth" fxLayoutAlign="center center">
                <textarea
                    class="form-control"
                    [(ngModel)]="userResult.comment"
                    (keyup)="setResult($event)"
                    placeholder="Escribe tu respuesta aquí"
                ></textarea>
            </div>
        }
    </div>
}

<!--:::| TRAFFIC LIGHT |:::-->
@if (element.type === "TRAFFIC_LIGHT") {
    <div fxLayout="row" style="width: 100%">
        @if (element.type === "TRAFFIC_LIGHT") {
            <div fxLayout="column" fxLayoutAlign="flex-end start" class="panel-status" fxFlex="80">
                <h1 fxFlex="100" class="m-0 elementHead">
                    {{ element.name }}
                    @if (element.required == 1) {
                        <b style="color: rgb(255, 50, 50)"> *</b>
                    }
                </h1>
            </div>
        }
        @if (element.type === "TRAFFIC_LIGHT") {
            <div
                fxLayout="column"
                fxLayoutAlign="flex-end end"
                class="panel-status"
                style="margin-right: 5%"
                fxFlex="20"
            >
                <!-- ReadOnly -->
                @if (readOnly && userResult?.result) {
                    <div fxLayout="row" fxLayoutAlign="flex-end center" style="opacity: 0.8">
                        <button
                            mat-mini-fab
                            class="ml-4 btn-success"
                            [class]="userResult?.result !== '100' ? 'no-select' : ''"
                            matTooltip="Completado"
                            matTooltipPosition="above"
                        >
                            <mat-icon>check</mat-icon>
                        </button>
                        <button
                            mat-mini-fab
                            class="ml-4 btn-warning"
                            [class]="userResult?.result !== '50' ? 'no-select' : ''"
                            matTooltip="En progreso"
                            matTooltipPosition="above"
                        >
                            <mat-icon>access_time</mat-icon>
                        </button>
                        <button
                            mat-mini-fab
                            class="ml-4 btn-danger"
                            [class]="userResult?.result !== '0' ? 'no-select' : ''"
                            matTooltip="No completado"
                            matTooltipPosition="above"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                        @if (element.noApplyOption) {
                            <button
                                mat-mini-fab
                                class="ml-4 btn-muted"
                                [class]="userResult?.result !== 'NA' ? 'no-select' : ''"
                                matTooltip="No aplica"
                                matTooltipPosition="above"
                            >
                                <mat-icon>pause</mat-icon>
                            </button>
                        }
                    </div>
                }
                <!-- WriteMode -->
                @if (!readOnly) {
                    <div fxLayout="row" class="botonera-planes-accion">
                        <button
                            mat-mini-fab
                            class="ml-4 btn-success"
                            [class]="userResult?.result !== '100' ? 'no-select' : ''"
                            matTooltip="Completado"
                            matTooltipPosition="above"
                            (click)="setResult('100')"
                        >
                            <mat-icon>check</mat-icon>
                        </button>
                        <button
                            mat-mini-fab
                            class="ml-4 btn-warning"
                            [class]="userResult?.result !== '50' ? 'no-select' : ''"
                            matTooltip="En progreso"
                            matTooltipPosition="above"
                            (click)="setResult('50')"
                        >
                            <mat-icon>access_time</mat-icon>
                        </button>
                        <button
                            mat-mini-fab
                            class="ml-4 btn-danger"
                            [class]="userResult?.result !== '0' ? 'no-select' : ''"
                            matTooltip="No completado"
                            matTooltipPosition="above"
                            (click)="setResult('0')"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                        @if (element.noApplyOption) {
                            <button
                                mat-mini-fab
                                class="ml-4 btn-muted"
                                [class]="userResult?.result !== 'NA' ? 'no-select' : ''"
                                matTooltip="No aplica"
                                matTooltipPosition="above"
                                (click)="setResult('NA')"
                            >
                                <mat-icon>pause</mat-icon>
                            </button>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
@if (element.description && element.type === "TRAFFIC_LIGHT") {
    <div fxLayout="row" fxLayoutAlign="start start" style="margin-right: 5%">
        <div fxFlex="100" class="m-0" [innerHtml]="element.description"></div>
    </div>
}

<!--RATING STARS-->
@if (element.type === "RATING_STARS") {
    <div fxLayout="row" style="width: 100%">
        @if (element.type === "RATING_STARS") {
            <div fxLayout="column" fxLayoutAlign="flex-end start" class="panel-status" fxFlex="80">
                <h1 fxFlex="100" class="m-0 elementHead">
                    {{ element.name }}
                    @if (element.required == 1) {
                        <b style="color: rgb(255, 50, 50)"> *</b>
                    }
                </h1>
            </div>
        }
        @if (element.type === "RATING_STARS") {
            <div
                fxLayout="column"
                fxLayoutAlign="flex-end end"
                class="panel-status"
                style="margin-right: 5%"
                fxFlex="20"
            >
                <item-stars-poll
                    [stars]="printStars(userResult?.result)"
                    [editable]="!readOnly"
                    [view]="'me'"
                    [canNA]="element.noApplyOption == 1"
                    (onStarsChange)="onChangeStarsValue($event, element)"
                >
                </item-stars-poll>
            </div>
        }
    </div>
}
@if (element.description && element.type === "RATING_STARS") {
    <div fxLayout="row" fxLayoutAlign="start start" style="margin-right: 5%">
        <div fxFlex="100" class="m-0" [innerHtml]="element.description"></div>
    </div>
}

<!-- Element comment -->
@if (element.allowComment === 1 && element.type !== "TEXTAREA") {
    <div>
        <!-- Read only -->
        @if (readOnly && userResult.comment) {
            <div style="margin-left: 5%">
                <!-- User -->
                @if (userResult.comment) {
                    <div fxLayout="row" fxLayoutAlign="center center" class="comment-container">
                        <div class="m-0 comment" [innerHtml]="userResult.comment"></div>
                    </div>
                }
            </div>
        }
        <!-- Write mode -->
        @if (!readOnly) {
            <div class="mt-16 fullwidth" fxLayoutAlign="center center">
                <textarea
                    class="form-control"
                    [(ngModel)]="userResult.comment"
                    placeholder="¿Desea incluir un comentario?"
                ></textarea>
            </div>
        }
    </div>
}
